import React from 'react';

const permissions = [
  {
    category: 'Payroll Permissions',
    items: [
      { key: 'payroll.read', description: 'View payslips', access: 'HR, Admin, Employee (own)' },
      { key: 'payroll.write', description: 'Generate payslips', access: 'HR, Admin' },
      { key: 'employee_password.read', description: 'View employee passwords (masked)', access: 'Admin' },
      { key: 'employee_password.write', description: 'Reset/set employee password', access: 'HR, Admin' },
      { key: 'employee_bankdetails.write', description: 'Update employee bank details', access: 'Admin' },
      { key: 'employee_offerdetails.write', description: 'Update employee bank details', access: 'Admin' },
      { key: 'employee_managerdetails.write', description: 'Update employee bank details', access: 'Admin' },
      { key: 'employee_details.write', description: 'Update employee bank details', access: 'Admin' },
      { key: 'employee_exitprocess.write', description: 'Update employee bank details', access: 'Admin' },
    ],
  },
  {
    category: 'HRMS Permissions',
    items: [
      { key: 'leaves.read', description: 'View leave requests', access: 'HR, Employee (own)' },
      { key: 'leaves.write', description: 'Apply or approve leave', access: 'Employee (self), HR' },
      { key: 'leaves.update', description: 'Modify leave details', access: 'HR' },
      { key: 'leaves.delete', description: 'Delete leave entries', access: 'HR' },
      { key: 'attendance.read', description: 'View attendance data', access: 'Employee (own), HR' },
      { key: 'attendance.write', description: 'Mark/update attendance', access: 'HR, Admin' },
      { key: 'documents.read', description: 'View uploaded employee documents', access: 'HR, Employee (own)' },
      { key: 'documents.write', description: 'Upload documents', access: 'HR' },
      { key: 'profile.update', description: 'Edit personal information', access: 'Employee (own), HR' },
    ],
  },
  {
    category: 'Sales/CRM Permissions',
    items: [
      { key: 'crm_data.read', description: 'View CRM/sales leads', access: 'Sales, Admin' },
      { key: 'crm_data.write', description: 'Create/update leads or follow-ups', access: 'Sales' },
    ],
  },
  {
    category: 'Employee Role Permissions',
    items: [
      { key: 'team.view', description: 'View reporting team', access: 'Managers, Leads' },
      { key: 'manager.view', description: 'View reporting manager', access: 'All Employees' },
      { key: 'payslip.download', description: 'Download personal payslip', access: 'Employee (own)' },
      { key: 'profile.edit_self', description: 'Edit own profile', access: 'All Employees' },
    ],
  },
];

export default function PermissionsGuide() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6 text-center">🔐 Suwashti Portal Permissions Guide</h1>
      {permissions.map((section, index) => (
        <div key={index} className="mb-10">
          <h2 className="text-xl font-semibold mb-4 text-blue-700">📁 {section.category}</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-2 border">Permission Key</th>
                  <th className="px-4 py-2 border">Description</th>
                  <th className="px-4 py-2 border">Access Given To</th>
                </tr>
              </thead>
              <tbody>
                {section.items.map((item, i) => (
                  <tr key={i} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border text-sm font-mono text-purple-700">{item.key}</td>
                    <td className="px-4 py-2 border">{item.description}</td>
                    <td className="px-4 py-2 border text-sm text-gray-700">{item.access}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
      <p className="text-sm text-gray-500 italic mt-8">
        ✅ <strong>Read</strong>: View-only access &nbsp;&nbsp; 📝 <strong>Write</strong>: Create entries &nbsp;&nbsp; ✏️ <strong>Update</strong>: Edit entries &nbsp;&nbsp; ❌ <strong>Delete</strong>: Remove entries
      </p>
    </div>
  );
}